import React, { useState } from 'react';
import {
  COUNTRY_FILTER_ALL,
  COUNTRY_FILTER_FEATURED,
  PLATFORM_PRODUCT_STATS,
  HERO_LANDING_STATS,
} from '../../config/constants';
import { getDisplayCountry } from '../../data/countries';
import { scrollToListingsAnchor } from '../../utils/properties';
import useReveal from '../../hooks/useReveal';

const PlatformStats = () => (
  <div className="hero-stats" aria-label="Platform highlights">
    {PLATFORM_PRODUCT_STATS.map((stat) => (
      <div key={stat.label} className="stat-item">
        <h3>{stat.value}</h3>
        <p>{stat.label}</p>
      </div>
    ))}
  </div>
);

const ListingsMarketHeader = ({
  country,
  onViewListings,
  headline,
  subline,
  compact = false,
  landing = false,
  search = "",
  onSearchChange,
  searchPlaceholder = "Enter city, state or property name...",
}) => {
  const c = getDisplayCountry(country);
  const multiMarket = country === COUNTRY_FILTER_FEATURED || country === COUNTRY_FILTER_ALL;
  const minLabel = multiMarket ? "$500" : `${c.symbol}${(500 * c.rate / 1000).toFixed(0)}K`;
  const [searchFocused, setSearchFocused] = useState(false);
  const [heroRef, heroVisible] = useReveal();

  if (landing) {
    return (
      <div
        ref={heroRef}
        className="hero hero--listings hero--landing hero--refined"
      >
        <div className="hero-ambient-orb hero-ambient-orb--1" aria-hidden="true"></div>
        <div className="hero-ambient-orb hero-ambient-orb--2" aria-hidden="true"></div>
        <div className="hero-ambient-orb hero-ambient-orb--3" aria-hidden="true"></div>

        <div className="hero-refined-inner">
          <div className={`reveal-up ${heroVisible ? "visible" : ""}`}>
            <div className="hero-badge">
              <span className="hero-badge-dot" aria-hidden="true"></span>
              <span className="hero-badge-text">Fractional real estate · tokenized ownership</span>
            </div>
          </div>

          <h1 className="hero-refined-title">
            <span className={`reveal-up delay-1 ${heroVisible ? "visible" : ""} hero-refined-title-line`}>
              Own Real Estate
            </span>
            <span className={`reveal-up delay-2 ${heroVisible ? "visible" : ""} hero-refined-title-accent`}>
              Together
            </span>
          </h1>

          <p className={`reveal-up delay-3 ${heroVisible ? "visible" : ""} hero-refined-lead`}>
            Invest in premium properties with as little as <strong>{minLabel}</strong>. Fund your CoOwn USD wallet by card or bank transfer, pay with USDC/ALGO at checkout, hold fractional shares, and receive on-chain ownership tokens when a property completes legal tokenization.
          </p>

          <div className={`reveal-up delay-4 ${heroVisible ? "visible" : ""} hero-stat-grid`} aria-label="Platform highlights">
            <div className="hero-stat-line" aria-hidden="true">
              <div className={`hero-stat-line-draw${heroVisible ? " visible" : ""}`} />
            </div>
            {HERO_LANDING_STATS.map((stat) => (
              <div key={stat.sub} className="hero-stat-card">
                <div className="hero-stat-card-value">{stat.label}</div>
                <div className="hero-stat-card-label">{stat.sub}</div>
              </div>
            ))}
          </div>

          {onViewListings && (
            <div className={`reveal-up delay-4 ${heroVisible ? "visible" : ""} hero-search-refined`}>
              <div className={`hero-search-panel${searchFocused ? " hero-search-panel--focused" : ""}`}>
                {typeof onSearchChange === "function" && (
                  <div className="hero-search-field">
                    <i className="fas fa-search" aria-hidden="true"></i>
                    <input
                      type="search"
                      placeholder="Search city, neighborhood, or property..."
                      value={search}
                      onChange={(e) => onSearchChange(e.target.value)}
                      onFocus={() => setSearchFocused(true)}
                      onBlur={() => setSearchFocused(false)}
                      aria-label="Search listings"
                    />
                  </div>
                )}
                <button type="button" className="hero-search-btn" onClick={onViewListings}>
                  <i className="fas fa-list-ul" aria-hidden="true"></i>
                  View listings
                </button>
              </div>
            </div>
          )}

          <button
            type="button"
            className={`reveal-up delay-4 ${heroVisible ? "visible" : ""} hero-scroll-indicator`}
            aria-label="Scroll to listings"
            onClick={() => scrollToListingsAnchor()}
          >
            <span className="hero-scroll-indicator-label">Scroll</span>
            <div className="hero-scroll-indicator-line" aria-hidden="true"></div>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`hero hero--listings${compact ? " hero--compact" : ""}${landing ? " hero--landing" : ""}`}>
      <h1>{headline}</h1>
      <p>{subline || `Invest in premium properties with as little as ${minLabel}. Pool resources, share ownership, and build wealth collectively.`}</p>
      <PlatformStats country={country} />
      {onViewListings && (
        <div className="hero-listings-explore">
          <div className="hero-listings-bar">
            {typeof onSearchChange === "function" && (
              <div className="hero-listings-search">
                <i className="fas fa-search" aria-hidden="true"></i>
                <input
                  type="search"
                  placeholder={searchPlaceholder}
                  value={search}
                  onChange={(e) => onSearchChange(e.target.value)}
                  aria-label="Search listings"
                />
              </div>
            )}
            <div className="hero-listings-market">
              <button type="button" className="country-selector--hero-bar hero-view-listings-btn" onClick={onViewListings}>
                <i className="fas fa-th-list" aria-hidden="true"></i>
                <span className="country-label-long">View listings</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export { PlatformStats };
export default ListingsMarketHeader;
